(() => {
    window.addEventListener("DOMContentLoaded", () => {
        const countrySelect = document.querySelector('#pricing-country-select')

        if (!countrySelect) {
            return
        }

        // Logic for pricing page country select
        countrySelect.addEventListener('change', () => {
            let target = countrySelect.querySelector('option[value=' + countrySelect.value + ']').getAttribute('data-target');
            new BSN.Modal(
              target
            ).show()
        });

        document.querySelectorAll('#maincontent .modal').forEach((modalElement) => {
            modalElement.querySelector('.modal-body').addEventListener('click', (e) => {
                e.stopPropagation()
            })

            modalElement.querySelector('.modal-header .close').addEventListener('click', () => {
                countrySelect.selectedIndex = 0
            })
        })

        window.setTimeout(function () {
            if(window.location.hash && document.querySelector('#pricing-country-select option[data-target="' + window.location.hash + '"]')) {
                new BSN.Modal(window.location.hash).show();
            }
        }, 300)
    })
}) ()

